import { baseColumns } from "./columns/baseColumns";
import { serviceColumns } from "./columns/serviceColumns";
import { scheduleAndCompletionColumns } from "./columns/scheduleAndCompletionColumns";
import { financialColumns } from "./columns/financialColumns";
import { feedbackAndRatingsColumns } from "./columns/feedbackAndRatingsColumns";
import { requestStatusColumns } from "./columns/requestStatusColumns";
import { actionColumns } from "./columns/actionColumns";

export const columns = [
  ...baseColumns,
  ...serviceColumns,
  ...scheduleAndCompletionColumns,
  ...financialColumns,
  ...feedbackAndRatingsColumns,
  ...requestStatusColumns,
  ...actionColumns,
];